<template>
  <div class="paper-warp">
    <h2 style="text-align: center;">电子结业证书</h2>
    <table class="cert-table" border="0">
      <tr
        v-for="(item, index) in certData"
        :key="index"
        class="cert-tr"
      >
        <td class="cert-td-1">{{ item.label }}</td>
        <td class="cert-td-2">{{ item.value }}</td>
      </tr>
    </table>
    <!-- <div class="remark">*修完全部教学课程，考试成绩合格，准允结业！</div> -->
  </div>
</template>

<script>
import { CertDetail } from '@/api/index'
import dayjs from 'dayjs'
const sortArr = [
  {
    label: '工种类型',
    key: 'cert_occupation',
  },
  {
    label: '等级/岗位',
    key: 'cert_post',
  },
  {
    label: '姓名',
    key: 'student_name',
  },
  {
    label: '性别',
    key: 'sex',
  },
  {
    label: '身份证号码',
    key: 'idcard',
  },
  {
    label: '工作单位',
    key: 'company',
  },
  {
    label: '培训日期',
    key: 'training_interval',
  },
  {
    label: '证书编号',
    key: 'cert_no',
  },
  {
    label: '发证日期',
    key: 'cert_date',
  },
  {
    label: '有效期',
    key: 'expiration',
  },
]
export default {
  name: 'CertificateTable',
  data() {
    return {
      sortObj: {},
      data: {},
      certData: {},
    }
  },
  computed: {},
  watch: {},
  created() {
    this.initSort()
    if (this.$route.query.id) {
      this.initPage(this.$route.query.id)
    } else {
      var obj = {}
      var query = window.location.href.split('?')[1]
      var vars = query.split('&')
      if (vars.length !== 0) {
        var pair = null
        for (var i = 0; i < vars.length; i++) {
          pair = vars[i].split('=')
          obj[pair[0]] = pair[1]
        }
        this.initPage(obj.id)
      }
    }
  },
  methods: {
    initSort() {
      // 定义序号
      const sortObj = {}
      sortArr.map((item, index) => {
        item.sort = index + 1
        sortObj[item.key] = item
      })
      this.sortObj = sortObj
    },
    async initPage(id) {
      if (!id) return
      const res = await CertDetail({
        id: this.$route.query.id,
      })
      this.data = res
      // const certData = res.cert_data.map((item) => {
      //   item.sort = this.sortObj[item.label] || 100
      //   return item
      // })
      const certData = []
      for (const key in res.cert_data) {
        if(this.sortObj[key])
          certData.push(this.dataFormat(res, key))
      }
      // 按序排列
      this.certData = certData.sort((a, b) => {
        return a.sort - b.sort
      })
      // console.log('this.data', this.data, this.certData)
    },
    dataFormat(res, key) {
      let response = {
        label: this.sortObj[key].label || '未知项',
        value: res.cert_data[key] || '--',
        sort: this.sortObj[key].sort || 100,
      }
      // 培训时间
      if(key == 'training_interval'){
        let time_arr = res.cert_data[key].split('-') || []
        if(time_arr.length == 2){
          let start_time = dayjs(time_arr[0]
              .replace('年', '-')
              .replace('月', '-')
              .replace('日', '')).format('YYYY年MM月')
          let end_time = dayjs(time_arr[1]
              .replace('年', '-')
              .replace('月', '-')
              .replace('日', '')).format('YYYY年MM月')
          response.value = start_time //+'-'+end_time
        }
      }
      return response
    }
  },
}
</script>

<style lang="scss" scoped>
.paper-warp {
  width: 100vw;
  height: 100%;
  position: relative;
  overflow-y: auto;
  padding: 12px;
}
.cert-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  border-right: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  td {
    padding: 5px 0;
    border-left: 1px solid #e1e1e1;
    border-top: 1px solid #e1e1e1;
  }
  .cert-tr {
    display: flex;
  }
  .cert-tr-spec {
    background: #d7e9f4;
  }
  .cert-td-1 {
    flex: 1;
  }
  .cert-td-2 {
    flex: 2;
  }
}
.remark {
  font-size: 12px;
  margin-top: 8px;
  color: #888;
  width: 100%;
  text-align: end;
}
</style>
